import { Button } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps 
{
    text?: string;
    onClick: ()=>void;
}

const DeleteButton: FC<IProps> = ({ text, onClick }) => 
{
    const { t } = useTranslation();
    
    return (<Button 
        color="secondary"
        onClick={onClick}
    >
        {text ?? t('buttons.delete')}
    </Button>);
};

export default DeleteButton;